// extracted by mini-css-extract-plugin
export default {"overlay":"SpinnerOverlay_overlay__87M2G","fixed":"SpinnerOverlay_fixed__tm7O+"};